import { type MaterialComponentInputValue, useApiTradeV1BuyerMaterialSpecificationsUpdate } from 'api';
import { useNavigate, useParams } from 'react-router-dom';

import { type UploadGenericDocumentProps } from '../../../document';
import { getBuyerMaterialSpecificationUrl } from '../../utils/getBuyerMaterialSpecificationListUrl/getBuyerMaterialSpecificationUrl';
import { useUploadAndCreateDocument } from '../useUploadAndCreateDocument/useUploadAndCreateDocument';

type UpdateBuyerMaterialSpecificationProps = {
  buyerMaterialSpecificationId: number;
  buyerId: number;
  materialGradeId: number;
  materialId: number;
  materialColourId?: number;
  materialFormId: number;
  materialComponents: MaterialComponentInputValue[];
  notes: string | undefined;
  document?: UploadGenericDocumentProps;
  packagingSpecificationIds: number[];
};

type HookProps = {
  onError?: (error: Error) => void;
};

export const useUpdateBuyerMaterialSpecification = ({ onError }: HookProps) => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const uploadAndCreateDocument = useUploadAndCreateDocument();
  const { mutateAsync, isPending } = useApiTradeV1BuyerMaterialSpecificationsUpdate({
    mutation: {
      onError: (error) => {
        onError?.(error);
      },
    },
  });

  const updateBuyerMaterialSpecification = async ({
    buyerMaterialSpecificationId,
    buyerId,
    materialGradeId,
    materialId,
    materialColourId,
    materialFormId,
    materialComponents,
    notes,
    document,
    packagingSpecificationIds,
  }: UpdateBuyerMaterialSpecificationProps) => {
    await mutateAsync({
      buyerMaterialSpecificationId,
      data: {
        buyer_id: buyerId,
        material_colour_id: materialColourId,
        material_component_values: materialComponents,
        material_form_id: materialFormId,
        material_grade_id: materialGradeId,
        material_id: materialId,
        notes: notes,
        packaging_specification_ids: packagingSpecificationIds,
      },
    }).then(async () => {
      if (document) {
        await uploadAndCreateDocument(Number(buyerMaterialSpecificationId), document);
      }
      navigate(getBuyerMaterialSpecificationUrl(Number(companyId)));
    });
  };
  return { isPending, updateBuyerMaterialSpecification };
};
